var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"now"},[_c('Header'),_c('div',{staticStyle:{"margin-top":"100px"}},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.closeMeeting.apply(null, arguments)}}},[_vm._v("CLOSE")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }